/*
Blog infinite scroll
*/
// something has scrolled into view
var isInView = function(el, buffer){
  var bounding = el.getBoundingClientRect();
  return bounding.top >= 0 &&
  (bounding.bottom - buffer) <= (window.innerHeight || document.documentElement.clientHeight);
};
// something is taking the full window height
var isWholeView = function(el){
  var bounding = el.getBoundingClientRect();
  return bounding.top <= 0 &&
  bounding.bottom >= (window.innerHeight || document.documentElement.clientHeight);
};
var $loader = $('#next-post-loader');
var fetchNextPost = function(){
  if( !isFetching ){
    if ( isInView(window.nextPostLink, 1000) ) {
      isFetching = true; // stop fetches while ajax is running
      $loader.addClass('working');
      $.ajax({
        url: window.nextPostLink.getAttribute('href'),
        success: function(data){
          // remove items that conflict with new content
          $('#comments').remove();
          $loader.remove();

          // inject new stuff
          var $dom = $(data);
          if (window.hasCalculator) {
            $dom.find('#wagering-calculator').remove(); // ids in this element will conflict with existing calculator
          }
          $('#article-container').append($dom.find('#article-container').html());
          $loader.removeClass('working');
          $b.trigger('postLoaded');

          // set up new fetch
          $loader = $('#next-post-loader');
          window.nextPostLink = $loader.find('a')[0];
          window.isFetching = false;
        }
      })
    }
  }
  // update browser history for article in view (top and bottom bounds are out of view, meaning you're seeing the body of the item)
  if (history.replaceState) {
    $('#article-container article').each(function(){
      let newPermalink = $(this).data('permalink');
      if (isWholeView($(this)[0]) && newPermalink !== currentPermalink) {
        currentPermalink = newPermalink;
        window.history.replaceState({ path: newPermalink }, '', newPermalink);
        document.title = $(this).data('meta-title');
      }
    });
  }
};
if( $loader.length ){
  var currentPermalink = $('#article-container article').data('permalink');
  // attaching these to window for scope clarity
  window.nextPostLink = $loader.find('a')[0];
  window.isFetching = false;
  window.addEventListener('scroll', _.throttle(fetchNextPost, 1000)); // lodash throttle to avoid constantly firing this
}

/*
Sharing
  */
$b.on('click', '.entry-sharing a.in-window', function(e){
  e.preventDefault(); 
  window.open($(this).attr('href'), 'shareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
});
